module.exports = __webpack_public_path__ + "static/media/img24.120bff52.jpeg";